<template>
<div>
  <div class="aw-imgbanner-container bg-black">
    <div class="img-caption">
    <div>
      <h1>Drinkmeny</h1>
      </div>

    </div>
  </div>
</div>
</template>